/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `MEDICAL` - Medical
 * * `DEA` - DEA (Drug Enforcement Administration)
 * * `CSR` - CSR (Controlled Substance Registration)
 * * `OTHER` - Other
 */
export enum LicenseTypeEnum {
    MEDICAL = 'MEDICAL',
    DEA = 'DEA',
    CSR = 'CSR',
    OTHER = 'OTHER',
}
